// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { parsePlatformRef } from "../operation/platformRef";
import AthleteCard from "./AthleteCard";
import StreamingLiveClient from "./StreamingLiveClient";

const AthleteStreamingRoute = () => {
  const params = useParams();
  const location = useLocation();
  const platformRef = parsePlatformRef(params.day, params.platformId);

  React.useEffect(() => {
    document.body.classList.add("wrpf-streaming-card");
    return () => document.body.classList.remove("wrpf-streaming-card");
  }, []);

  // Pure WebSocket display: the data comes from the live broadcast, and the stream PC/OBS source often
  // has no meet loaded. So we only require a well-formed URL — not that the local meet declares the
  // platform (that wrongly rejected platform 2 with "Invalid Streaming URL").
  if (platformRef === null) {
    return <main role="alert">Invalid Streaming URL</main>;
  }

  return (
    <StreamingLiveClient platformRef={platformRef} locationSearch={location.search} followPolicy="immediate-next">
      {(state) => <AthleteCard {...state} />}
    </StreamingLiveClient>
  );
};

export default AthleteStreamingRoute;
